export default __webpack_public_path__ + "static/media/venue_location_icon.fdcd72ec.svg";